import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { IMainMenuDropdown } from '@app-store';
import { DisplayWithAuthPipe } from '@blocks/header/pipes/display-with-auth.pipe';
import { NavigateToUrlDirective } from '@core/directive/navigate-to-url/navigate-to-url.directive';
import { AuthStore } from '@pages/auth/auth-store';
import { MenuItemLinkType } from '@utils/enum/menu-item-link-type.enum';
import { IMenuItemLink } from '@utils/interfaces/menu-item-link.model';
import { APP } from 'src/app/app.constant';

@Component({
  selector: 'app-mobile-main-menu',
  templateUrl: './mobile-main-menu.component.html',
  styleUrls: ['./mobile-main-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [RouterModule, DisplayWithAuthPipe, NavigateToUrlDirective]
})
export class MobileMainMenuComponent implements OnInit {
  @Input() menuItems: (IMainMenuDropdown & IMenuItemLink)[];
  @Output() menuItemSelect = new EventEmitter<void>();

  // Computed properties for better performance
  readonly authInfo = computed(() => this.authStore.authInfo());

  MenuItemType: typeof MenuItemLinkType = MenuItemLinkType;

  private readonly authStore = inject(AuthStore);

  constructor(private readonly router: Router) {}

  @HostListener('click', ['$event.target'])
  onClick(target: HTMLElement): void {
    if (target.tagName === 'A') {
      this.menuItemSelect.emit();
    }
  }

  ngOnInit(): void {}

  login(): void {
    this.router.navigateByUrl(APP.LOGIN_URL);
  }

  logout(): void {
    this.authStore.logout();
  }
}
